/* istanbul ignore file */

const successLarge = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Success Large</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.3726 5.3726 0 12 0C18.6274 0 24 5.3726 24 12C24 18.6274 18.6274 24 12 24C5.3726 24 0 18.6274 0 12ZM19.0607 9.06066L16.9393 6.93934L10.5 13.3787L8.06066 10.9393L5.93934 13.0607L10.5 17.6213L19.0607 9.06066Z"
      fill="#34A270"
    />
  </svg>
);

export default successLarge;
